import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const SponsoredTagContainer = styled(View, theme => {
  return {
    base: {
      height: theme.sizingExtrasmall,
      backgroundColor: theme.colorFillNeutralAlternative,
      borderWidth: theme.borderWidthNone,
      borderRadius: theme.borderRadiusPill,
      borderColor: theme.colorNone,
      paddingHorizontal: theme.paddingInsetTwopulse,
      paddingVertical: theme.paddingInsetNone,
      justifyContent: 'center',
      width: 'auto',
      position: 'absolute',
      bottom: 0,
      left: 0,
    },
  }
})

export const SponsoredTagTitle = styled(Text, theme => {
  return {
    base: {
      color: theme.colorTextNeutralPlaceholder,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreepulse,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
    },
  }
})
